class AccordionImage {
	constructor(container) {
		this.el = container;
		this.images = this.el.querySelectorAll('.accordion__image-wrapper');

		this.init();
	}

	init() {
		this.el.addEventListener('accordionActiveChanged', (e) => {
			const accHeading = e.detail;

			this.images.forEach(img => {
				img.classList.remove('active');
			});

			if (accHeading) {
				let found = false;
				this.images.forEach(img => {
					if (img.dataset.image === accHeading) {
						img.classList.add('active');
						found = true;
					}
				});
				if (!found) {
				}
			} else {
			}
		});

		const firstActive = this.el.querySelector('.accordion-container__header.active');
		if (firstActive) {
			const event = new CustomEvent('accordionActiveChanged', {
				detail: firstActive.dataset.accHeading,
			});
			this.el.dispatchEvent(event);
		} else {
		}
	}
}

export default AccordionImage;
